import { getLiteral } from 'utils/getLiteral';

export default () => ({
    columnDefs: [
        {
            colId: 'numLine',
            headerName: '#',
            field: 'numLine',
            headerComponent: 'headerTextCell',
            cellRenderer: 'textCell',
            width: 60,
            resizable: false,
            pinned: 'left',
            suppressSizeToFit: true,
        },
        {
            colId: 'companyName',
            headerName: getLiteral('title_company'),
            field: 'companyname',
            headerComponent: 'headerTextCell',
            cellRenderer: 'textCell',
            flex: 1,
            suppressSizeToFit: false,
        },
    ],
});
